var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.link ? 'router-link' : 'div',{tag:"component",staticClass:"countable-badge",style:({ backgroundImage: ("url(" + (_vm.badge.preview.url) + ")") }),attrs:{"to":_vm.link ? '/badge-info' : false,"target":"_blank"}})}
var staticRenderFns = []

export { render, staticRenderFns }